import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            {/* Brand Logo */}
            <div className="orange-logo">
              <img src="/assets/helpdesk/logo.svg" alt={t.logoAlt} width="160" height="70" />
            </div>

            {/* Discover Column */}
            <div className="footer-column">
              <h4 className="column-title">{t.discover.title}</h4>
              <ul className="footer-links">
                {t.discover.links.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* More Column */}
            <div className="footer-column">
              <h4 className="column-title">{t.more.title}</h4>
              <ul className="footer-links">
                {t.more.links.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Side - App Download & Social */}
            <div className="footer-right">
              <div className="app-download">
                <h4 className="column-title">{t.appDownload.title}</h4>
                <div className="store-buttons">
                  <a
                    href={t.appDownload.googlePlay.href}
                    className="store-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={t.appDownload.googlePlay.alt}
                  >
                    <img
                      src={t.appDownload.googlePlay.badge}
                      alt={t.appDownload.googlePlay.alt}
                      width="135"
                      height="40"
                    />
                  </a>
                  <a
                    href={t.appDownload.appStore.href}
                    className="store-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={t.appDownload.appStore.alt}
                  >
                    <img
                      src={t.appDownload.appStore.badge}
                      alt={t.appDownload.appStore.alt}
                      width="120"
                      height="40"
                    />
                  </a>
                </div>
              </div>

              <div className="social-section">
                <h4 className="column-title">{t.social.title}</h4>
                <div className="social-icons">
                  {t.social.channels.map((channel, index) => (
                    <a
                      key={index}
                      href={channel.href}
                      className="social-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={channel.name}
                    >
                      <img src={channel.icon} alt={channel.name} width="28" height="28" />
                      <span>{channel.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="footer-bottom">
        <div className="container">
          <div className="bottom-content">
            <div className="bottom-logo">
              <img src="/assets/helpdesk/logo.svg" alt={t.logoAlt} width="32" height="32" />
            </div>
            <p className="copyright">
              <span>{currentYear}</span> {t.copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
